// ===== sened1.js =====
import React, { useState } from "react";
import "./sened.css";

function titleCaseFirst(text) {
    if (!text) return "";
    return text
        .split(" ")
        .filter(Boolean)
        .map((word) => {
            const lower = word.toLowerCase();
            return lower.charAt(0).toUpperCase() + lower.slice(1);
        })
        .join(" ");
}

function removePatronymicMarkers(text) {
    if (!text) return "";
    return text
        .replace(/\b(oğl[auy]|oglu|ogly|o'glu|oglu)\b/gi, "")
        .replace(/\s+/g, " ")
        .trim();
}

export default function Sened1() {
    const [surnameNamePatronymic, setSNP] = useState("");
    const [marka, setMarka] = useState("");
    const [model, setModel] = useState("");
    const [ban, setBan] = useState("");
    const [sariNomre, setSariNomre] = useState("");
    const [reng, setReng] = useState("");
    const [year, setYear] = useState("");
    const [muherikNomresi, setMuherikNomresi] = useState("");

    function handleSNPChange(e) {
        let raw = e.target.value;

        // birdən çox boşluğu tək boşluğa çevir
        raw = raw.replace(/\s+/g, " ");

        // başda və sonda boşluqları sil
        raw = raw.trimStart();

        // hər sözdə ilk hərfi böyük, qalanları kiçik
        let fixed = raw
            .split(" ")
            .map((word) => {
                if (!word) return "";
                const lower = word.toLowerCase();
                return lower.charAt(0).toUpperCase() + lower.slice(1);
            })
            .join(" ");

        setSNP(fixed);
    }

    function handleMarkaChange(e) {
        setMarka(titleCaseFirst(e.target.value));
    }

    function handleModelChange(e) {
        setModel(titleCaseFirst(e.target.value));
    }

    function handleBanChange(e) {
        setBan(e.target.value.toUpperCase());
    }

    function handleSariChange(e) {
        const v = e.target.value.replace(/[^0-9]/g, ""); // yalnız rəqəm
        setSariNomre(v.slice(0, 4));
    }

    function handleRengChange(e) {
        // rəqəmləri sil və sözləri title-case et
        const noDigits = e.target.value.replace(/[0-9]/g, "");
        setReng(titleCaseFirst(noDigits));
    }

    function handleYearChange(e) {
        const v = e.target.value.replace(/[^0-9]/g, "");
        setYear(v.slice(0, 4));
    }

    // 2) Yeni handler (digər handle* funksiyalarının yanına əlavə edin)
    function handleMuherrikChange(e) {
        setMuherikNomresi(e.target.value.toUpperCase());
    }

    function buildMessage() {
        const driverRaw = removePatronymicMarkers(surnameNamePatronymic);
        const driver = titleCaseFirst(driverRaw);

        const markaSend = titleCaseFirst(marka);
        const modelSend = titleCaseFirst(model);
        const tipiSend = "Moped";
        const banSend = ban.toUpperCase();
        const identSend = sariNomre;
        const rengSend = titleCaseFirst(reng);
        const yilSend = year;
        const muherikSend = muherikNomresi.toUpperCase();

        const lines = [
            `Sürücü: ${driver}`,
            `Marka: ${markaSend}`,
            `Model: ${modelSend}`,
            `Tipi: ${tipiSend}`,
            `Ban nömrəsi: ${banSend}`,
            `Mühərrik nömrəsi: ${muherikSend}`, // <-- əvvəl boş idi, indi doldurulur
            `İdentifikasiya nömrəsi: ${identSend}`,
            `Rəngi: ${rengSend}`,
            `İstehsal tarixi: ${yilSend}`,
            `Mühərrik həcmi: 49 sm³`,
            `Maksimal sürət: 45 km/saat`,
            "", // ← boş sətir
            "https://chat.whatsapp.com/BiWK6xphZBaIReuja0PM4K?mode=ems_copy"
        ];

        return lines.join("\n");
    }

    function handleSubmit(e) {
        e.preventDefault();

        const wordsCount = surnameNamePatronymic.trim().split(/\s+/).filter(Boolean).length;
        if (wordsCount < 3) {
            alert("Zəhmət olmasa, Soyad, Ad və Ata adını tam yazın.");
            return;
        }

        if (!marka) {
            alert("Zəhmət olmasa, Marka daxil edin.");
            return;
        }
        if (!model) {
            alert("Zəhmət olmasa, Model daxil edin.");
            return;
        }
        if (!ban) {
            alert("Zəhmət olmasa, Ban nömrəsini daxil edin.");
            return;
        }
        if (!sariNomre) {
            alert("Zəhmət olmasa, Sarı nömrəni daxil edin (yalnız rəqəm, maks 4)."
            );
            return;
        }
        if (!reng) {
            alert("Zəhmət olmasa, Rəngi daxil edin.");
            return;
        }
        if (!year || year.length !== 4) {
            alert("Zəhmət olmasa, 4 rəqəmli istehsal ilini daxil edin (məsələn: 2022).");
            return;
        }

        if (!muherikNomresi) {
            alert("Zəhmət olmasa, Mühərrik nömrəsini daxil edin.");
            return;
        }

        const message = buildMessage();
        const phone = "994709559984";
        const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    }

    return (
        <div className="sened1-container">
            <h2>Sənədləri doldurun</h2>
            <form className="sened1-form" onSubmit={handleSubmit}>
                <label>
                    Soyad, Ad, Ata adı
                    <input
                        placeholder="Soyad, Ad, Ata adı"
                        value={surnameNamePatronymic}
                        onChange={handleSNPChange}
                    />
                </label>
                <div className="helper-text">
                    Nümunə: <strong>Məmmədov Qafar Şahin</strong>
                    <div className="note">Qeyd: "oğlu", "qızı" sözünə ehtiyac yoxdur!</div>
                </div>

                <label>
                    Marka
                    <input placeholder="Nümunə: Rks" value={marka} onChange={handleMarkaChange} />
                </label>

                <label>
                    Model
                    <input placeholder="Nümunə: Sniper" value={model} onChange={handleModelChange} />
                </label>

                <label>
                    Ban nömrəsi
                    <input placeholder="Nümunə: AB102C3DFGFH12345" value={ban} onChange={handleBanChange} />
                </label>

                <label>
                    Mühərrik nömrəsi
                    <input
                        placeholder="Nümunə: 1A23BCD123456789"
                        value={muherikNomresi}
                        onChange={handleMuherrikChange}
                    />
                </label>

                <label>
                    Sarı nömrə (yalnız rəqəm, maks 4)
                    <input
                        placeholder="Nümunə: 1234"
                        value={sariNomre}
                        onChange={handleSariChange}
                        inputMode="numeric"
                    />
                </label>

                <label>
                    Rəngi
                    <input placeholder="Nümunə: Qara" value={reng} onChange={handleRengChange} />
                </label>

                <label>
                    İstehsal tarixi (YYYY)
                    <input
                        placeholder="Nümunə: 2022"
                        value={year}
                        onChange={handleYearChange}
                        inputMode="numeric"
                        maxLength={4}
                    />
                </label>

                <button type="submit" className="send-btn">
                    Sənədləri göndər
                </button>
            </form>
        </div>
    );
}

